import React from 'react';
import fr from 'facet-rest';
import { WorkflowLayout } from 'Components/ComponentLibrary/Organisms/WorkflowLayout/WorkflowLayout';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  FDBackButton, FDContentContainer, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { FDInputRow } from 'Packages/FacetDesign/Components/Experimental/fdInputRow';
import { TextButtonRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/TextButtonRel';
import { dataAttrs } from 'Helpers/Testing';

const BeneficiaryPersonInHousehold = () => {
  const { resource } = useMetaLayoutContext();

  if (resource.attr('beneficiaryKind') !== 'beneficiaryPersonInHousehold') {
    return null;
  }

  return (
    <>
      <FDInputRow>
        <MetaControlField attr={'member'} />
        <MetaControlField attr={'phoneNumber'} />
      </FDInputRow>
      <TextButtonRel relationship={resource.relationship(fr.relationships.profilePage.name)} alignSelf="center" />
    </>
  );
};

const BeneficiaryPersonNotInHousehold = () => {
  const { resource } = useMetaLayoutContext();

  if (resource.attr('beneficiaryKind') !== 'beneficiaryPersonNotInHousehold') {
    return null;
  }

  return (
    <>
      <FDInputRow>
        {/* Person not in household */}
        <MetaControlField attr={'firstName'} />
        <MetaControlField attr={'lastName'} />
      </FDInputRow>
      <FDInputRow>
        {/* Person not in household */}
        <MetaControlField attr={'phoneNumber'} />
        <MetaControlField attr={'birthDate'} />
      </FDInputRow>
      <FDInputRow>
        {/* Person not in household */}
        <MetaControlField attr={'socialSecurityNumber'} />
      </FDInputRow>
    </>
  );
};

const BeneficiaryNotPerson = () => {
  const { resource } = useMetaLayoutContext();

  if (resource.attr('beneficiaryKind') !== 'beneficiaryNotPerson') {
    return null;
  }

  return (
    <FDInputRow>
      {/* Not a person */}
      <MetaControlField attr={'name'} />
      <MetaControlField attr={'phoneNumber'} />
      <MetaControlField attr={'taxIDNumber'} />
    </FDInputRow>
  );
};

export const AccountOpeningV2BeneficiaryDetailStepLayout = () => {
  const { resource, onSubmit, handleChange } = useMetaLayoutContext();
  const { loadPageContentLink } = usePageContentContext();
  const hasSelectedBeneficiaryKind = !!resource.attr('beneficiaryKind');

  return (
    <WorkflowLayout appearance={'elevated'}>
      <FDContentContainer maxWidth="sm">
        <FDStack direction={'column'} spacing={8}>
          <FDStack direction={'column'} spacing={2}>
            <MetaControlField attr={'title'} />
            <MetaControlField attr={'description'} />
            {hasSelectedBeneficiaryKind ? null : <MetaControlField attr={'beneficiaryKind'} />}
            <BeneficiaryPersonInHousehold />
            <BeneficiaryPersonNotInHousehold />
            <BeneficiaryNotPerson />
          </FDStack>
          <FDStack alignItems={'center'} justifyContent={'center'} spacing={2}>
            {resource.withRelationship(fr.relationships.back.name, (rel) => {
              const onClick = hasSelectedBeneficiaryKind ? () => {
                handleChange('beneficiaryKind', '');
              } : () => {
                loadPageContentLink(rel.link('related'));
              };
              return (
                <FDBackButton
                  label={rel.meta('prompt')}
                  onClick={onClick}
                />
              );
            }, () => null)}
            {resource.meta().canPost() ? (
              <FDPrimaryActionButton
                {...dataAttrs('continue-btn', resource)}
                disabled={!resource.isValid()}
                label={resource.attr('primaryActionLabel')}
                onClick={() => onSubmit()}
              />
            ) : null}
          </FDStack>

        </FDStack>
      </FDContentContainer>
    </WorkflowLayout>
  );
};
